import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { AccordionCivilStatus } from 'shell/view-models/accordion-civil-status';
import { FormikTouched, FormikErrors } from 'formik';
import CivilStatusList from 'shell/components/shared/civil-status-list';

interface FormCivilStatusProps {
  disabled?: boolean;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionCivilStatus>;
  touched?: FormikTouched<AccordionCivilStatus>;
  values?: AccordionCivilStatus;
  onChange: (
    key: keyof AccordionCivilStatus,
    value: AccordionCivilStatus[keyof AccordionCivilStatus]
  ) => void;
}

const FormCivilStatusComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: FormCivilStatusProps): React.ReactElement => {
  const handleCivilStatusListChange = useEventCallback((element: string | undefined) => {
    onChange('status', element);
  });

  return (
    <Grid container spacing={1}>
      <Grid item container spacing={1} xs={12} alignItems="center">
        <Grid item xs={12} md={6}>
          <CivilStatusList
            label="Stato civile"
            aria-label="Stato civile"
            value={values?.status || ''}
            onChange={handleCivilStatusListChange}
            error={touched?.status && Boolean(errors?.status)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs>
          <FormControlLabel
            control={
              <Checkbox
                id="availableStatus"
                checked={values?.available || false}
                onChange={() => onChange('available', !values?.available)}
                inputProps={{ 'aria-label': 'Stato civile non disponibile' }}
                disabled={isEditMode ? false : disabled}
              />
            }
            label="Stato civile non disponibile"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

FormCivilStatusComponent.displayName = 'Form civil status component';

const FormCivilStatus = memo(FormCivilStatusComponent);

export default FormCivilStatus;
